import { Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { IGroup } from '@app-types/api/email';

@Component({
  selector: 'app-email-group-list',
  imports: [TranslateModule],
  templateUrl: './email-group-list.component.html',
  styleUrls: ['./email-group-list.component.scss'],
})
export class EmailGroupListComponent {
  @Input() groups?: IGroup[];

  constructor() {}
}
